import useViewport from './useViewport';

/**
 * @example
 * // (say, window.innerWidth = 1400)
 * useBreakpointValue<string>({
 * 	0: 'mobile',
 * 	1280: 'laptop',
 * 	1920: 'desktop'
 * }) // => 'laptop'
 */

export default function useBreakpointValue<T>(
  valueMap: Record<number, T>,
  debounce?: number
) {
  const { width } = useViewport({ debounce });
  return getValueForBreakpoint(width, valueMap);
}

export function getValueForBreakpoint<T>(
  width: number,
  mappings: Record<number, T>
): T {
  const keys = Object.keys(mappings).map(Number);
  if (!keys.length) throw new Error('At least one value should be provided');
  const sorted = keys.sort((a, b) => +b - +a);
  const match = sorted.find((n) => width > +n);
  return mappings[match || sorted[sorted.length - 1]];
}
